<template>
  <div>
    <Modal :visible="visible" @ok="$emit('ok')" @cancel="$emit('cancel')" class="h-5/6">
      <div>
        <div class="tx-1" v-html="confirmData.message"></div>
        <div class="btn">
          <div>
            <a-button class="btn1 btn-left" @click="cancelPopup"
              ><span>いいえ</span></a-button
            >
          </div>
          <div>
            <a-button class="btn1 btn-right" @click="redirectUrl"
              ><span>はい</span></a-button
            >
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Modal } from '@/components/primitive'

export default {
  components: {
    Modal
  },
  props: {
    confirmData: {
      type: Object,
      default: () => ({
        code: '',
        message: '',
        confirmLink: '',
        familySerialNumber: true
      })
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    cancelPopup() {
      this.$emit('cancel')
    },
    toQueryString(paramsObject) {
      return Object.keys(paramsObject)
        .map((key) => `${key}=${paramsObject[key]}`)
        .join('&')
    },
    redirectUrl() {
      const params = {
        return_url: window.location.href,
        subscription_id: this.$auth?.user?.ssoSubscriptionId,
        bo_service_code: this.CONST_DATA.BO_CODE.BS//,
//        force_re_authentication: true // #71902 対応として、アカウント管理ポータルに遷移する際に再認証が求められないようにするため、パラメータを外す対応
      }
      if (this.confirmData.code === 3) {
        params['host_flg'] = this.confirmData.familySerialNumber
      }
      const queryParams = this.toQueryString(params)
      window.open(`${this.confirmData.confirmLink}?${queryParams}`)
      this.cancelPopup()
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
